/** Arch + tick — the Postern mark, identical to the product's Mark.tsx and the original site. */
export default function Mark({ size = 26, color = "#EAA221" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true" focusable="false">
      <path d="M8 28V14a8 8 0 0116 0v14" stroke={color} strokeWidth="2.5" />
      <path d="M17.2 20.2l1.3 1.3 2.3-2.6" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
